import { SourceInput } from '../../../../../../common/SourcesInfoLabel/types';
import { Source } from './types';

export const toSourceInputs = (sources: Source[] = []): SourceInput[] =>
    sources.map(({ url, sourceName, dataPoint }) => ({ url, name: sourceName, subHeading: dataPoint }));
